const DB_NAME = "quincaillerie-offline";
const DB_VERSION = 1;

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains("cache")) db.createObjectStore("cache");
      if (!db.objectStoreNames.contains("queue")) db.createObjectStore("queue", { keyPath: "ref" });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function cacheSet(key, value) {
  const db = await openDb();
  return new Promise((res, rej) => {
    const t = db.transaction("cache", "readwrite");
    t.objectStore("cache").put(value, key);
    t.oncomplete = res;
    t.onerror = () => rej(t.error);
  });
}

export async function cacheGet(key) {
  const db = await openDb();
  return new Promise((res, rej) => {
    const r = db.transaction("cache").objectStore("cache").get(key);
    r.onsuccess = () => res(r.result);
    r.onerror = () => rej(r.error);
  });
}

export async function queueAdd(sale) {
  const db = await openDb();
  return new Promise((res, rej) => {
    const t = db.transaction("queue", "readwrite");
    t.objectStore("queue").put(sale);
    t.oncomplete = res;
    t.onerror = () => rej(t.error);
  });
}

export async function queueAll() {
  const db = await openDb();
  return new Promise((res, rej) => {
    const r = db.transaction("queue").objectStore("queue").getAll();
    r.onsuccess = () => res(r.result || []);
    r.onerror = () => rej(r.error);
  });
}

export async function queueRemove(ref) {
  const db = await openDb();
  return new Promise((res, rej) => {
    const t = db.transaction("queue", "readwrite");
    t.objectStore("queue").delete(ref);
    t.oncomplete = res;
    t.onerror = () => rej(t.error);
  });
}
